import React, { useEffect } from 'react'
import { Box, Typography } from '@mui/material'
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/outline'
import { Button as DesignSystemButton } from '../../../../interaxDesignSystemComponents'
import { INTERAX_COLORS, INTERAX_TYPOGRAPHY } from '../../../../constants/colors'

interface AssessmentModalButtonWrapperProps {
  onPrevious: () => void
  onNext: () => void
  previousLabel: string
  nextLabel: string
  continueLabel: string
  isPreviousDisabled: boolean
  isNextDisabled: boolean
  isLastQuestion: boolean
  isSaving: boolean
  savingLabel: string
}

export const AssessmentModalButtonWrapper: React.FC<AssessmentModalButtonWrapperProps> = ({
  onPrevious,
  onNext,
  previousLabel,
  nextLabel,
  continueLabel,
  isPreviousDisabled,
  isNextDisabled,
  isLastQuestion,
  isSaving,
  savingLabel
}) => {
  const nextButtonLabel = isSaving ? savingLabel : isLastQuestion ? continueLabel : nextLabel

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Enter' && !isNextDisabled) {
        onNext()
      }
    }
    document.addEventListener('keydown', handleKeyDown)
    return () => document.removeEventListener('keydown', handleKeyDown)
  }, [isNextDisabled, onNext])

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: 2
      }}
    >
      <DesignSystemButton
        variant="secondary"
        onClick={onPrevious}
        disabled={isPreviousDisabled || isSaving}
        icon={<ChevronLeftIcon className="w-4 h-4" />}
        iconPosition="left"
      >
        {previousLabel}
      </DesignSystemButton>

      <Typography
        sx={{
          ...INTERAX_TYPOGRAPHY.body3,
          color: INTERAX_COLORS.thunderGrey,
          display: { xs: 'none', md: 'block' }
        }}
      >
        Press Enter to continue
      </Typography>

      <DesignSystemButton
        variant="primary"
        onClick={onNext}
        disabled={isNextDisabled}
        icon={!isSaving ? <ChevronRightIcon className="w-4 h-4" /> : undefined}
        iconPosition="right"
      >
        {nextButtonLabel}
      </DesignSystemButton>
    </Box>
  )
}
